export default "__VITE_ASSET__587d0acc__"